import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-step-two-mautic',
  templateUrl: './step-two-mautic.component.html',
  styleUrls: ['./step-two-mautic.component.scss']
})
export class StepTwoMauticComponent implements OnInit {

  formData: any = {};
  @ViewChild('form', { static: false }) form: ElementRef<any>;

  constructor(
    router: ActivatedRoute,
    @Inject('FORM_API_URL') public formApiUrl: string
  ) { 

    router.queryParams.subscribe(
      query => {
          this.formData = query;
          
          setTimeout(() => this.form.nativeElement.submit(), 500);
      }
    )

  }

  ngOnInit(): void {
  }

}
